module.exports = __webpack_public_path__ + "onibus.30bd595b60df3fbcdf1be91c50abcdee.jpg";